export const INTENT_STORAGE_KEY = "passport.launch.intent";
export const PLAYER_STORAGE_KEY = "passport.launch.playerId";
// FOOTGUN: this key holds the course GUID (e.g. "cl_74ud8389799552") from the launch
// context, NOT the numeric passport courseID. Resolve via `courseGUID` (getStudentCourses)
// before using it as a route param or assignments-API arg.
export const CLASS_ID_STORAGE_KEY = "passport.launch.classId";
export const ACTIVITY_ID_STORAGE_KEY = "passport.launch.activityId";
export const LAUNCH_ID_STORAGE_KEY = "passport.launch.launchId";
export const SCHOOL_ID_STORAGE_KEY = "passport.launch.schoolId";
export const ROLE_STORAGE_KEY = "passport.launch.role";

export const INTENT_PICK = "PICK";
export const INTENT_PERFORM = "PERFORM";
export const INTENT_VIEW = "VIEW";

export const ROLE_TEACHER = "teacher";
export const ROLE_STUDENT = "student";

export type LaunchIntent = typeof INTENT_PICK | typeof INTENT_PERFORM | typeof INTENT_VIEW;
